import { AssetInfo } from './../../../models/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { ApiService } from 'src/app/providers/api.service';
import { Component, Inject, OnInit, OnDestroy, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BuisnessPromotion } from 'src/app/models/common';
import { TOUCH_BUFFER_MS } from '@angular/cdk/a11y';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';

@Component({
  selector: 'sm-add-documents',
  templateUrl: './add-documents.component.html',
  styleUrls: ['./add-documents.component.scss']
})
export class AddDocumentsComponent implements OnInit, OnDestroy {
  public buisnessPromotionData: BuisnessPromotion = new BuisnessPromotion();
  public documentData:any = {}
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public loader: boolean = false;
  private _assetInfo: AssetInfo[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private _ngZone: NgZone,
    private loaderservice: LoaderServiceService
  ) {}

  removeAsset(index: any) {
    console.log(index);
    this.assetList.splice(index, 1);
  }

  ngOnInit(): void {
    let data: any = new BuisnessPromotion();

    Object.assign(data, this.parentData.data);
    console.log(data);
    if (data.hashId) {
      
      this.editMode = true;
      this.documentData.name = data.documentName
      this.documentData.description = data.documentDescription
    }
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result.url);
        this.assetList = []
        this._ngZone.run(() => {
          this.assetList.push({
            assetName: this.fileName,
            url: res.result?.url,
            thumbnail: res.result?.thumbnail,
          });
          console.log(this.assetList);
          this.loader = false;
        });
        // this.buisnessPromotionData.imgUrl = res.result?.url;
      }
      if (res.responseType === SM_CONSTANTS.UPDATE_BUSINESS_DOCS_STATUS_RESULT) {
        if (data) {
         
          this.parentData.ref.closeAll();
        } 
      }
    });
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
    
    if(this.editMode){
      let data = {
        hashId: this.parentData.data.hashId,
        documentName: this.documentData.name,
        documentDescription: this.documentData.description
      }
      this.loaderservice.showLoader = true
      this._apiService.updateBusinessDocsStatus(data)
    }
    else if(!this.editMode){
      let data = {
        documentUrl: this.assetList[0].url,
        documentThumbUrl: this.assetList[0].thumbnail,
        documentName: this.documentData.name,
        documentDescription: this.documentData.description,
        businessHashId: this.parentData.data
      }
      this.loaderservice.showLoader = true
      this._apiService.updateBusinessDocsStatus(data)
    }
    
  }

  onUploadImage(event: any) {
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;

    if (this.fileName.includes(' ')) {
      this.fileName = this.fileName.replace(/\s+/g, '_');
    }
    let sizeinKb = +event.target.files[0].size / 1000;
    // if (sizeinKb > 1021) {
    //   this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
    //   return;
    // }
    let extension = this.fileName.substring(this.fileName.lastIndexOf('.') + 1);
    console.log(extension);
    // this.assetList.push({
    //   assetName: this.fileName,
    // });
    this.loader = true;
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
      console.log('image');
      if (sizeinKb > 5120) {
        this.loader = false;
        this._snackBar.open(
          'Image size should not exceed more then 1 mb',
          'Ok'
        );
        return;
      }
      this._apiService.uploadAssets(formData, 1);
      return;
    }
    if (extension === 'mp4' || extension === 'avi') {
      if (sizeinKb > 15360) {
        // this.loader = false;
        this._snackBar.open(
          'Image size should not exceed more then 1 mb',
          'Ok'
        );
        return;
      }
      console.log('Video');
      this._apiService.uploadAssets(formData, 3);
      return;
    }
    this.loader = false;
    this._snackBar.open('File format not supported', 'Ok');

    // this._apiService.uploadAssets(formData, 1);
  }

  locationAutoComplete(event: any) {
    console.log('location', event.place.address_components);
    // administrative_area_level_1 = state
    // locality = city
    // country = country
    event.place.address_components?.forEach((data: any) => {
      let type = data.types[0];
      console.log(type);
      if (type === 'administrative_area_level_1') {
        this.buisnessPromotionData.targetState = data?.long_name;
      } else if (type === 'locality') {
        this.buisnessPromotionData.targetCity = data.long_name;
      } else if (type === 'country') {
        this.buisnessPromotionData.targetCountry = data.long_name;
      }
    });
  }
}

